import { connect } from 'react-redux';
import MobileToolbar from './MobileToolbar';
import { setDialogOpen, setLegendDrawerOpen } from '../securitySlice';

const mapStateToProps = state => ({
  affiliateTableChange: state.security.affiliateTableChange,
  userTableChange: state.security.userTableChange,
});

const mapDispatch = {
  setDialogOpen,
  setLegendDrawerOpen,
};

export default connect(mapStateToProps, mapDispatch)(MobileToolbar);
